import { useIsAdmin } from '../lib/session';

/** "Exportar CSV" of a list with its current filters (Admin only, like the API). */
export function ExportCsvButton({
  dataset,
  params,
  className = 'btn',
}: {
  dataset: string;
  params?: URLSearchParams | Record<string, string>;
  className?: string;
}) {
  const isAdmin = useIsAdmin();
  if (!isAdmin) return null;
  const p = new URLSearchParams(params);
  p.delete('limit');
  p.delete('cursor');
  const qs = p.toString();
  return (
    <a className={className} href={`/api/v1/exports/${dataset}.csv${qs ? `?${qs}` : ''}`} download>
      Exportar CSV
    </a>
  );
}
